import { List, Record } from "immutable";

export const COURSE_EXAM_QUESTIONS_SPEC_TYPE: "course-exam-questions" =
  "course-exam-questions";

export type CourseExamQuestionsSpecType = {
  courseId: string | null;
  questionIds: List<string>;
};

type CourseExamQuestionsSpecJS = {
  courseId: string;
  questionIds: string[];
};

const defaultCourseExamQuestionsSpec: CourseExamQuestionsSpecType = {
  courseId: null,
  questionIds: List()
};

export default class CourseExamQuestionsSpec extends Record(
  defaultCourseExamQuestionsSpec
) {}

export function fromJS(
  values: CourseExamQuestionsSpecJS
): CourseExamQuestionsSpec {
  return new CourseExamQuestionsSpec({
    ...values,
    questionIds: List(values.questionIds)
  });
}
